import React, { useEffect, useState, Component } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ReferralPage } from './pages/ReferralPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouReferralPage } from './pages/ThankYouReferralPage';
import { AiCoursePage } from './pages/AiCoursePage';
import { LandingPage1 } from './pages/LandingPage1';
import { LandingPage2 } from './pages/LandingPage2';
import { LandingPage3 } from './pages/LandingPage3';
import { LandingPage11 } from './pages/LandingPage11';
import { LandingPage12 } from './pages/LandingPage12';
import { LandingPage13 } from './pages/LandingPage13';
import { LandingPage14 } from './pages/LandingPage14';
import { LandingPage21 } from './pages/LandingPage21';
import { LandingPage22 } from './pages/LandingPage22';
import { LandingPage23 } from './pages/LandingPage23';
import { LandingPage24 } from './pages/LandingPage24';
import { LandingPage25 } from './pages/LandingPage25';
import { LandingPage30 } from './pages/LandingPage30';
import { LandingPage31 } from './pages/LandingPage31';
import { LandingPage32 } from './pages/LandingPage32';
import { LandingPage40 } from './pages/LandingPage40';
import { LandingPage41 } from './pages/LandingPage41';
import { LandingPage42 } from './pages/LandingPage42';
import { LandingPage43 } from './pages/LandingPage43';
import { LandingPage44 } from './pages/LandingPage44';
import { LandingPage45 } from './pages/LandingPage45';
import { LandingPage51 } from './pages/LandingPage51';
import { LandingPage52 } from './pages/LandingPage52';
import { LandingPage53 } from './pages/LandingPage53';
import { LandingPage60 } from './pages/LandingPage60';
import { LandingPage61 } from './pages/LandingPage61';
import { LandingPage62 } from './pages/LandingPage62';
import { LandingPage63 } from './pages/LandingPage63';
import { LandingPage71 } from './pages/LandingPage71';
import { LandingPage72 } from './pages/LandingPage72';
import { LandingPage73 } from './pages/LandingPage73';
import { LandingPage74 } from './pages/LandingPage74';
import { LandingPage75 } from './pages/LandingPage75';
import { LandingPage81 } from './pages/LandingPage81';
import { LandingPage82 } from './pages/LandingPage82';
import { LandingPage83 } from './pages/LandingPage83';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PricingProvider } from './contexts/PricingContext';
import { SEO } from './components/SEO';
import { captureUTMParams } from './utils/utm';
import { Routes, Route } from 'react-router-dom';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  // Capture UTM params on initial load
  useEffect(() => {
    captureUTMParams();
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
      // Re-capture UTM params on navigation
      captureUTMParams();
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // Routing logic
  let PageComponent = LandingPage;
  let pageName = 'home';
  // Normalize path to handle language prefixes (en, ru, ua)
  let normalizedPath = currentPath;
  if (currentPath.startsWith('/ru')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/ua')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/uk')) {
    // Handle legacy 'uk' prefix as 'ua'
    normalizedPath = currentPath.substring(3);
  }
  if (normalizedPath === '') normalizedPath = '/';
  if (normalizedPath === '/referral') {
    PageComponent = ReferralPage;
    pageName = 'referral';
  } else if (normalizedPath === '/privacy') {
    PageComponent = PrivacyPage;
    pageName = 'privacy';
  } else if (normalizedPath === '/terms') {
    PageComponent = TermsPage;
    pageName = 'terms';
  } else if (normalizedPath === '/thank-you') {
    PageComponent = ThankYouPage;
    pageName = 'thankYou';
  } else if (normalizedPath === '/thank-you-referral') {
    PageComponent = ThankYouReferralPage;
    pageName = 'thankYouReferral';
  } else if (normalizedPath === '/courses/ai-websites') {
    PageComponent = AiCoursePage;
    pageName = 'aiCourse';
  } else if (normalizedPath === '/1') {
    PageComponent = LandingPage1;
    pageName = 'home';
  } else if (normalizedPath === '/2') {
    PageComponent = LandingPage2;
    pageName = 'home';
  } else if (normalizedPath === '/3') {
    PageComponent = LandingPage3;
    pageName = 'home';
  } else if (normalizedPath === '/11') {
    PageComponent = LandingPage11;
    pageName = 'home';
  } else if (normalizedPath === '/12') {
    PageComponent = LandingPage12;
    pageName = 'home';
  } else if (normalizedPath === '/13') {
    PageComponent = LandingPage13;
    pageName = 'home';
  } else if (normalizedPath === '/14') {
    PageComponent = LandingPage14;
    pageName = 'home';
  } else if (normalizedPath === '/21') {
    PageComponent = LandingPage21;
    pageName = 'home';
  } else if (normalizedPath === '/22') {
    PageComponent = LandingPage22;
    pageName = 'home';
  } else if (normalizedPath === '/23') {
    PageComponent = LandingPage23;
    pageName = 'home';
  } else if (normalizedPath === '/24') {
    PageComponent = LandingPage24;
    pageName = 'home';
  } else if (normalizedPath === '/25') {
    PageComponent = LandingPage25;
    pageName = 'home';
  } else if (normalizedPath === '/30') {
    PageComponent = LandingPage30;
    pageName = 'home';
  } else if (normalizedPath === '/31') {
    PageComponent = LandingPage31;
    pageName = 'home';
  } else if (normalizedPath === '/32') {
    PageComponent = LandingPage32;
    pageName = 'home';
  } else if (normalizedPath === '/40') {
    PageComponent = LandingPage40;
    pageName = 'home';
  } else if (normalizedPath === '/41') {
    PageComponent = LandingPage41;
    pageName = 'home';
  } else if (normalizedPath === '/42') {
    PageComponent = LandingPage42;
    pageName = 'home';
  } else if (normalizedPath === '/43') {
    PageComponent = LandingPage43;
    pageName = 'home';
  } else if (normalizedPath === '/44') {
    PageComponent = LandingPage44;
    pageName = 'home';
  } else if (normalizedPath === '/45') {
    PageComponent = LandingPage45;
    pageName = 'home';
  } else if (normalizedPath === '/51') {
    PageComponent = LandingPage51;
    pageName = 'home';
  } else if (normalizedPath === '/52') {
    PageComponent = LandingPage52;
    pageName = 'home';
  } else if (normalizedPath === '/53') {
    PageComponent = LandingPage53;
    pageName = 'home';
  } else if (normalizedPath === '/60') {
    PageComponent = LandingPage60;
    pageName = 'home';
  } else if (normalizedPath === '/61') {
    PageComponent = LandingPage61;
    pageName = 'home';
  } else if (normalizedPath === '/62') {
    PageComponent = LandingPage62;
    pageName = 'home';
  } else if (normalizedPath === '/63') {
    PageComponent = LandingPage63;
    pageName = 'home';
  } else if (normalizedPath === '/71') {
    PageComponent = LandingPage71;
    pageName = 'home';
  } else if (normalizedPath === '/72') {
    PageComponent = LandingPage72;
    pageName = 'home';
  } else if (normalizedPath === '/73') {
    PageComponent = LandingPage73;
    pageName = 'home';
  } else if (normalizedPath === '/74') {
    PageComponent = LandingPage74;
    pageName = 'home';
  } else if (normalizedPath === '/75') {
    PageComponent = LandingPage75;
    pageName = 'home';
  } else if (normalizedPath === '/81') {
    PageComponent = LandingPage81;
    pageName = 'home';
  } else if (normalizedPath === '/82') {
    PageComponent = LandingPage82;
    pageName = 'home';
  } else if (normalizedPath === '/83') {
    PageComponent = LandingPage83;
    pageName = 'home';
  }
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <PricingProvider data-id="element-2">
          <SEO page={pageName} data-id="element-3" />
          <PageComponent data-id="element-4" />
        </PricingProvider>
      </LanguageProvider>
    </ThemeProvider>;
}